import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const provideCoreTranslation = () => provideTranslateService({
  fallbackLang: 'en-CA',
  lang: 'en-CA',
  loader: provideTranslateHttpLoader({
    prefix: '/locale/',
    suffix: '.json',
  }),
});
